const forgotPasswordUrl = 'https://maisvendas.somalabs.com.br/forgotPassword';

export { forgotPasswordUrl };
